import { dashSeoPerformaceUrl } from 'mk2/apps/dash/urls';
import { DynamicRoute } from 'mk2/containers/Application/Application';

export const routes: DynamicRoute[] = [{
    app: 'dash',
    exact: true,
    path: dashSeoPerformaceUrl,
    getPage: () => {
        return import('mk2/apps/dash/containers/SeoPerformance/SeoPerformancePage' /* webpackChunkName: "dash.SeoPerformance" */);
    },
    modules: [ 'mk2/apps/dash/containers/SeoPerformance/SeoPerformancePage' ],
}];
